import React from "react";
import { SidebarItem } from "@components/Catalyst/sidebar";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { LinkEntry } from "../data";

const MenuTopLevel = ({ item }: { item: LinkEntry }) => {
  const [open, setOpen] = React.useState(false);

  if (item.href)
    return (
      <SidebarItem href={item.href} key={item.label}>
        {item.element || item.label || ""}
      </SidebarItem>
    );

  return (
    <div className={`bg-${item.brandCode}`}>
      <SidebarItem
        onClick={() => {
          setOpen(!open);
        }}
      >
        {item.element || item.label || ""}{" "}
        <ChevronDownIcon className={`transform transition-transform duration-300 ${open ? "rotate-180" : "rotate-0"}`} />
      </SidebarItem>

      {open && (
        <div className="flex flex-col pl-2">
          {(item.children ?? []).map((itemx) => (
            <MenuTopLevel item={itemx} key={`${item.label}-${itemx.label}`} />
          ))}
        </div>
      )}
    </div>
  );
};

export default MenuTopLevel;
